export const productType = {
  storeSpecial: 'storeSpecial',
  pass: 'pass',
  normalOffer: 'normalOffer',
  gemPack: 'gemPack',
} as const

export type ProductTypes = (typeof productType)[keyof typeof productType]
